import { observer } from 'mobx-react-lite'
import { Button, Typography } from 'shared/ui'
import { type AddOnsStore } from 'pages/settings/pages/addOns/store/addOnsStore'
import styles from './styles.module.scss'

type IModalActionsProps = {
  store: AddOnsStore
}

export const ModalActions = observer(({ store }: IModalActionsProps) => {
  const { isActiveCustomDomain } = store.entities.shortLinkStore

  return (
    <div className={styles.actions}>
      <Typography
        ariaLabel='RegistrationRequired'
        variant='body-sm-regular'
        color='var(--content-primary-tertiary)'
        tag='div'
        className={styles.registrationRequired}
      >
        Registration is required
      </Typography>

      <Button
        text='Cancel'
        onClick={store.closeBrandedUrlShortenerModal}
        typeBtn={'contained'}
        size={'medium'}
        contained={'secondary'}
      />
      <Button
        text={isActiveCustomDomain ? 'Go to settings' : 'Register'}
        onClick={store.brandedUrlShortenerOnActionClick}
        typeBtn={'contained'}
      />
    </div>
  )
})
